import { render, staticRenderFns } from "./FaceVerify.vue?vue&type=template&id=46f2f064&scoped=true"
import script from "./FaceVerify.vue?vue&type=script&lang=js"
export * from "./FaceVerify.vue?vue&type=script&lang=js"
import style0 from "./FaceVerify.vue?vue&type=style&index=0&id=46f2f064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2f064",
  null
  
)

export default component.exports